// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"kngZJ":[function(require,module,exports) {
require("1431fa6ea2cdc91f").register(require("491f8199d5631fa3").getBundleURL("4oMEl"), JSON.parse('["4oMEl","index.1ca8f6c7.js","8TEaR","frame-21-2.5a555d7e.svg","6DZvv","frame-17-2.3151b1fc.svg","jPEzP","worker.2a57633e.png","aUpj1","placeholder.512da104.png","hryd9","trailbluvideo.34f4d9e4.mp4","dVJQp","coloredFibaBanka.7fb2db4a.png","8Bj2F","coloredAktifBank.e775bc59.png","15YBe","osigoLogo.92b5039a.png","6IAtQ","imeceLogo.b0b331fc.png","kN4r7","turkiyesigorta.8352a9cd.png","je3O9","mobile-web-app-testing.633577fe.svg","933fB","data-driven-testing.2b1a8bb7.svg","7MvFS","visual-testing.d059f405.svg","gx8Za","frame-17-1.cda09989.svg","vlgBg","frame-17.f0731216.svg","eSXM3","Logo.d59ea1f7.png","bYig5","menuIcon.fb1f72dc.png","bbXTh","footer.37a846b1.png","kum87","capterra.7a47a480.svg","5Yliq","getApp.8409d752.png","gPjMU","TrailbluIntro.da3a49e6.png","9AZd9","profile.39da575e.jpg","48Ayt","visualTesting.b8854283.png","k5yZ3","generativeAI.d26a072a.png","8IGV4","qatar_event.3f6c769a.png","6umI2","p21.2fae429a.png","7uIbN","flutterTesting.681fa9ee.png","8xwuj","p31.f76b6ba5.png","7QTa1","revolutionizetestingAI1.66f9e73c.png","giq6j","codelessAutomated.1be6be62.png","enFuR","ContinuousTesting2.b7b703d0.png","blpXp","RegressionTesting1.1da52bb4.png","7IdOQ","scalingSoftwareTestingAI.4aba1723.png","aDGLz","endToEndTesting.d91249bc.png","3csSv","crossDeviceTesting.0a9daeae.png","4mGW8","profitCenterTesting.3683948c.png","bkopb","seleniumPlaywrightTesting.6cda924c.png","fbM2J","deviceFarm.b2b9133f.png","9u0b2","testAutomation.f03e5450.png","3SL4s","validationVerification.8750bbdc.png","f9aqu","p3.6cbcf2e9.png","1LHZb","p2.52b2dcd2.png","4wuC0","p22.9e5f4266.png","77xk1","flutterTesting2.b736b2e4.png","4KdLv","flutterTesting3.ad603ff4.png","6wK9V","generativeAI2.13235141.png","i7S9y","generativeAI3.b568445d.png","fesCI","qatar.31be1fe7.png","hIU4H","qatar_event2.7bc86066.png","dEdyw","revolutionizetestingAI2.e31dd0c4.png","cuxkw","ContinuousTesting1.fdf53e31.png","e9J6F","TrailbluNoCodeTesting.61ac6ae4.gif","hXEwb","TrailbluSelfHealing.07b6d22b.gif","EaJTa","TrailbluVisualTesting.36235996.gif","5Oi9o","TrailbluGenAI.0b2ac43b.gif","8LHUm","killerFeatureGenAI.7ec76e29.png","7vfnx","killerFeatureNoCode.99673061.png","jgM19","killerFeatureSelfHealing.db589f7d.png","6v2LV","killerFeatureVisualTesting.e19e0d06.png","9SfL8","1write.bb0c16f7.svg","dtSXB","2groupOfPeople.9bf9a387.svg","10GNZ","3RocketLaunching.df79e9c8.svg","e18Tz","4FixedSetting.9dc42b11.svg","62CBw","1puzzle-piece.f26e506e.svg","UfEgD","2stopwatch.168e76b4.svg","280mW","3shield.1cf4f3d3.svg","78O7L","4danger.ec699758.svg","gB9w0","5transparency.2ad7ee61.svg","9scor","6quality.fb71439b.svg","9U0cj","1magnifying-glass.149046e5.svg","bO6H2","2target.342a8945.svg","eoknG","3responsive.0b62c3c7.svg","aEbBp","4screenshot.c2043cf9.svg","6tYdn","5analyzing.5c62edc9.svg","K9BFT","1guarantee.d361dc46.svg","c0KWU","2automatic.fc813c8d.svg","h3690","3shield-update.22ef117d.svg","5Zi85","4increasing-bar.615c73ce.svg","8RM7J","5decreasing-bar.f0fb167e.svg","eBUYk","index.4dd274cb.css"]'));

},{"1431fa6ea2cdc91f":"fyJL2","491f8199d5631fa3":"c7Tr5"}],"fyJL2":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["kngZJ"], null, "parcelRequireb8e7")

//# sourceMappingURL=index.runtime.cff148e4.js.map
